module.exports = __webpack_public_path__ + "img/9788959402106.a896c639.jpg";